export default __webpack_public_path__ + "static/waves-ab817023f58d54f1e64c3776ec0e3358.svg";